import React from 'react'
import {useQuery} from '@apollo/react-hooks'
import gql from 'graphql-tag'

import Helmet from '../common/helmet'
import TitledTab from '../common/titledTab'
import BlogPosts from '../blogPosts'
import useStyles from './styles'
import Loader from '../common/loader';
import GraphqlError from '../dev/graphqlError';

const SPORT = gql`
	query Sport($slug: String!) {
		sport(slug: $slug) {
			id
			slug
			averages
			divisions
			info
			name
			odds
		}
	}
`;

const SportsItem = ({match: {params: {id: slug}}}) => {
	const classes = useStyles();

	const {loading, error, data} = useQuery(SPORT, {variables: {slug}});

	if (loading) return <Loader/>;
	if (error) return <GraphqlError error={error}/>;

	const {sport: {
		id, averages, divisions, info, name, odds
	}} = data;

	return (
		<>
			<Helmet
				title={`College Sports - ${name}`}
				description="TBD"
			/>
			<div className={classes.container}>
				<TitledTab title={`College Sports - ${name}`}>
					<div className={classes.description}>
						{/*<h2 className={classes.h2}>{name}</h2>*/}
						<p>
							{/*Explore the {(new Date()).getFullYear()} top-ranked colleges in each state across the U.S. to find a good one near you.*/}
						</p>

						{divisions && (
							<h4>
								Schools sponsored varsity {name} teams in {(new Date()).getFullYear()}:
							</h4>
						)}
						{divisions && (
							<div className={classes.limitWidth}>
								<table className={classes.table}>
									<thead>
										{divisions.headers.map((row) => (
											<tr>
												{row.map((col) => (
													col.span ? (
														<td className={classes.center} colSpan={col.span}>
															{col.text}
														</td>
													) : (
														<td>{col}</td>
													)
												))}
											</tr>
										))}
									</thead>
									<tbody>
										{divisions.values.map((row) => (
											<tr>
												{row.map((col) => (
													<td>{col ? col.toLocaleString('en') : '-'}</td>
												))}
											</tr>
										))}
									</tbody>
								</table>
							</div>
						)}
						{divisions && divisions.captions && (
							divisions.captions.map((row) => (
								<p>{row}</p>
							))
						)}

						{odds && (
							<h4>
								Odds of a High School {name} Player competing in College {(new Date()).getFullYear()}:
							</h4>
						)}
						{odds && (
							<table className={classes.table}>
								<thead>
									<tr>
										<td></td>
										{odds.type === 'male-female' ? (
											<>
												<td>Male</td>
												<td>Female</td>
											</>
										) : (
											<td>Total</td>
										)}
									</tr>
								</thead>
								<tbody>
									{odds.values.map((row) => (
										<tr>
											{row.map((col) => (
												<td>{col ? col.toLocaleString('en') : '-'}</td>
											))}
										</tr>
									))}
								</tbody>
							</table>
						)}
						{odds && odds.state_title && (
							<><br/><h4>{odds.state_title}</h4></>
						)}
						{odds && odds.state_captions && (
							odds.state_captions.map((caption) => (
								<p>{caption}</p>
							))
						)}
						{odds && odds.state && (
							<table className={classes.table}>
								<thead>
									<tr>
										<td>Rank</td>
										<td>State</td>
										<td>Odds</td>
									</tr>
								</thead>
								<tbody>
									{odds.state.map((row, index) => (
										<tr>
											<td>{index + 1}</td>
											<td>{row[0]}</td>
											<td>{row[1]}</td>
										</tr>
									))}
								</tbody>
							</table>
						)}
						{odds && odds.state_male_female && (
							<table className={classes.table}>
								<thead>
									<tr>
										<td>State</td>
										<td>Male</td>
										<td>Female</td>
									</tr>
								</thead>
								<tbody>
									{odds.state_male_female.map((row) => (
										<tr>
											<td>{row[0]}</td>
											<td>{row[1]}</td>
											<td>{row[2]}</td>
										</tr>
									))}
								</tbody>
							</table>
						)}
					</div>
				</TitledTab>
				<div className={classes.sidebar}>
					<BlogPosts slug="sports"/>
				</div>
			</div>
		</>
	);
}

export default SportsItem;
